module.exports = __webpack_public_path__ + "img/earn.09203d40.png";